
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';

  import { catchError, from, map, mergeMap, Observable, of, switchMap } from 'rxjs';
  import { UserService } from '../services/user.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  /**
   * Creates an instance of TokenInterceptor.
   * @param {IdentityAuthService} auth
   * @memberof TokenInterceptor
   */
  constructor(public auth: UserService) { }

  /**
   * Intercept all HTTP request to add JWT token to Headers
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   * @returns {Observable<HttpEvent<any>>}
   * @memberof TokenInterceptor
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip token injection for health check endpoints to avoid circular dependencies
    // Skip token injection for refresh token endpoint to avoid infinite loop
    if (request.url.includes('/health') || !this.auth.isSignedIn || request.url.includes('auth/mobile/refresh')) {
      return next.handle(request);
    }

    return from(this.auth.ensureValidToken()).pipe(switchMap(() => {
      return of(this.auth.getAccessToken())
      .pipe(
        map(token => {
          if (token) {
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            });
          }
          return request;
        }),
        catchError((err) => {
          return of(request);
        }))
      .pipe(mergeMap(req => next.handle(req)));
    }));
  }
}
